<template>
  <div :class="'item-editor-' + index">
    <editor-wrapper>
    <template v-slot:default="{ apiKey, loading }">
    <editor
      v-if="!loading" 
      :apiKey="apiKey"
      tinymce-script-src="/tinymce/tinymce.min.js"
      class="item-editor"
      :init="initEditor"
      @onInit="onReady"
    />
    <loading v-if="loading" />
    </template> 
    </editor-wrapper>
    <el-upload
      class="upload-demo"
      action="/imageUpload.action"
      :show-file-list="false"
      :http-request="httpRequestEditor"
      accept="image/png, image/jpeg,image/gif"
      style="display: none"
    >
      <el-button size="small" type="primary" :ref="'uploadImage' + index"
        >点击上传</el-button
      >
      <div slot="tip" class="el-upload__tip">
        只能上传jpg/png文件，且不超过500kb
      </div>
    </el-upload>
  </div>
</template>

<script>
import { uploadFile } from "@/utils/axios";
import Editor from "@tinymce/tinymce-vue";
import EditorWrapper from './EditorWrapper';
import Loading from './Loading';

export default {
  name: "cEditor",
  props: ["content", "index", "getLength", "getEditor"],
  data() {
    return {
      //编辑器相关
      initEditor: {
        width: 959,
        min_height: 360,
        max_height: 800,
        menubar: false,
        statusbar: false,
        selector: "#tinydemo",
        plugins: [
          "code indent2em lineheight image axupimgs lists paste autoresize link table wordcount ax_wordlimit formatpainter powerpaste",
          "searchreplace",
        ],
        toolbar: [
          "undo redo removeformat formatpainter styleselect fontsizeselect bold italic underline strikethrough forecolor backcolor alignleft aligncenter alignright alignjustify | indent2em bullist numlist searchreplace superscript subscript code table blockquote link axupimgs lineheight pastetext",
        ],
        style_formats: [
          { title: "大标题", format: "h2" },
          { title: "小标题", format: "h3" },
          { title: "正文", format: "p" },
          { title: "参考文献", format: "h5" },
        ],
        fontsize_formats: "18.72px 24px 20px 18px 16px 12px",
        content_style:
          "p {font-size: 16px} h5 {font-size: 12px; font-weight: 400} img{max-width: 950px}",
        icons: "content-platform",
        icons_url: "/tinymce/icons/content-platform/icons.js",
        language: "zh_CN",
        language_url: "/tinymce/langs/zh_CN.js",
        browser_spellcheck: true, // 拼写检查
        branding: false, // 去水印
        powerpaste_allow_local_images: true,
        powerpaste_html_import: "prompt",
        powerpaste_word_import: "merge", // 是否保留word粘贴样式  clean | merge
        paste_data_images: true, // 设置为“true”将允许粘贴图像，而将其设置为“false”将不允许粘贴图像。
        paste_preprocess: async (plugin, args) => {
          let htmlstr = args.content;
          var reg = /<img.+?src=('|")?([^'"]+)('|")?(?:\s+|>)/gim;

          if (!reg.exec(htmlstr)) {
            return;
          }

          let arr = reg.exec(htmlstr)[2];

          let blob = await fetch(arr).then((r) => r.blob());
          const file = new window.File([blob], "file", { type: blob.type });

          this.uploadFileEditor(file, (msg) => {
            let url = `//image.healthjd.com/da/` + msg;
            let html = '<img style="max-width:950px" src="' + url + '" />';
            this.editor.insertContent(html);
          });
        },
        // images_upload_base_path: '//image.healthjd.com/da/',
        // 多图片上传
        images_upload_handler: async (blobInfo, succFun, failFun) => {
          const file = blobInfo.blob();
          console.log("多图片上传", blobInfo, file);
          this.uploadFileEditor(file, (url) => {
            succFun(`//image.healthjd.com/da/${url}`);
          });
        },
        // paste_as_text: true,
        toolbar_sticky: true,
        autoresize_bottom_margin: 0,
        ax_wordlimit_num: 30000,
        ax_wordlimit_callback: (editor, txt, num) => {
          var wordCountDom = document.querySelector(
            ".item-editor-" + this.index + " .wordCount"
          );
          if (wordCountDom) {
            wordCountDom.style.color = "#f92a2a";
            wordCountDom.innerHTML = "字数超出最大允许值，服务器可能拒绝保存！";
          }
        },
        ax_wordlimit_editor: (editor, txt, num) => {
          var wordCountDom = document.querySelector(
            ".item-editor-" + this.index + " .wordCount"
          );
          if (wordCountDom) {
            wordCountDom.style.color = "#A4A9B3";
            wordCountDom.innerHTML = this.computWords(txt) + "/" + num;
          }
        },
        clickImage: (editor) => {
          this.$refs["uploadImage" + this.index].$el.click(editor);
        },
        setup: (editor) => {
          editor.on("blur", (e) => {
            this.$emit("blurEditorEvent", e.target, this.index);
          });
        },
      },
      editor: "",
    };
  },
  components: {
    Editor,
    EditorWrapper,
    Loading,
  },
  watch: {
    content(newVal, oldVal) {
      newVal && this.editor && this.editor.setContent(newVal);
    },
  },
  mounted() {},
  created() {},
  methods: {
    onReady(e) {
      this.editor = e.target;
      this.editor && this.editor.setContent(this.content);
      let num = this.computWords(this.content) || 0;

      let editorContent = document.querySelector(
        ".item-editor-" + this.index + " .tox-editor-container"
      );
      let div = document.createElement("div"); //创建一个li
      div.setAttribute("class", "wordCount");
      div.innerHTML = num + "/30000";
      editorContent.appendChild(div);

      this.$emit("editorReady", {
        editor: e.target,
        index: this.index,
      });
      this.$emit("getEditor", {
        editor: e.target.getContent(),
        index: this.indexs,
      });
      // if (this.form.id) {
      //   app_type == 'user' ? this.searchArticleById() : this.getArticleByPid()
      // }
    },
    // 计算编辑框的文字数量
    computWords(txt) {
      this.$emit(
        "getLength",
        $("<div>" + txt + "</div>")
          .text()
          .trim().length
      );
      this.$emit("getEditor", {
        editor: this.editor.getContent(),
        index: this.indexs,
      });
      return $("<div>" + txt + "</div>")
        .text()
        .trim().length;
    },
    httpRequestEditor(request) {
      this.uploadFileEditor(request.file, (msg) => {
        let url = `//image.healthjd.com/da/` + msg;
        let html = '<img style="max-width:950px" src="' + url + '" />';
        this.editor.insertContent(html);
        console.log("html", html, this.editor.target.getContent());
        this.$emit("getEditor", {
          editor: this.editor.getContent(),
          index: this.indexs,
        });
      });
    },
    uploadFileEditor(file, callback) {
      uploadFile(file, (event) => {
        let percent = parseInt((event.loaded / event.total) * 100 + "");
        if (percent > 99) {
          percent = 99;
        }
        file.progress = percent;
        file.status = "pending";
      })
        .then((res) => {
          const id = res.data[0]["id"];
          if (id === "1") {
            const url = res.data[0]["msg"];
            callback && callback(url);
            file.status = "resolve"; // 是否上传成功，根据是否有url来判断
          } else if (id === "0") {
            this.$message.error("图片上传失败");
          }
        })
        .catch((error) => {
          file.status = "reject";
          this.$message.error("图片上传失败");
        });
    },
  },
};
</script>

<style lang="scss"></style>
